import React from "react";
import {longColour, shortColour} from "../../../../style/styleConsts";
import styled from "styled-components";

const directionColourMapping = {
    SHORT: shortColour,
    LONG: longColour
};

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 20px;
    width: 96px;
    height: 50px;
    background-color: ${props => props.backgroundColor};
`;

const Direction = ({direction}) => {
    return <Container backgroundColor={directionColourMapping[direction]}>
        <div>{direction}</div>
    </Container>;
};

export default Direction;